//NOTE : THIS IS NOT A REAL MIXIN !!!
//THIS IS A HELPER CLASS FOR APP SPECIFIC DATA TO BE LOADED ...
//WILL NOT HAPPEN A LOT BUT IT'S USEFULL FOR SERVERS THAT DO NOT SUPPORT SUBDOMAINS ...
import appSettings from "../../mixins/config/appSettings";

const app_id = appSettings.data().appSettings.applicationID;

export const AppBoundDataStorageHelper = {
    getAppBoundDataForKey(key) {
        let storedData = localStorage.getItem(key);
        if (storedData) {
            try {
                let data = JSON.parse(storedData);
                if (data[app_id] !== undefined && data[app_id] !== null) {
                    return data[app_id];
                } else {
                    //return null
                    return null;
                }
            } catch (se) {
                //REMOVE IT ...
                localStorage.removeItem(key);
                //return null
                return null;
            }
        }
        //return null
        return null;
    },
    storeAppBoundDataForKey(key, value) {
        let storedData = localStorage.getItem(key);

        let data = {}

        if (storedData) {
            try {
                data = JSON.parse(storedData);
                if(typeof(data) !== 'object'){
                    data = {}
                }
            } catch (e) {
                localStorage.removeItem(key);
            }
        }

        data[app_id] = value;

        try {
            localStorage.setItem(key, JSON.stringify(data));
            return true;
        } catch (e) {
            return false;
        }
    }
}